import script from "./CardSlider.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardSlider.vue?vue&type=script&lang=ts&setup=true"

import "./CardSlider.vue?vue&type=style&index=0&id=dd6c3a56&lang=scss"

const __exports__ = script;

export default __exports__